export default "__VITE_ASSET__ee21f5a6__"